// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"88":"74df7397","92":"d0df3e40","97":"cf24731d","120":"3ea17591","130":"38f45498","189":"b7ff7af9","236":"38f45498","352":"3d541ca7","490":"78b74e3c","554":"ef975822","631":"8984c0d6","779":"069e2887","783":"e71a4536","938":"abaf0b48"}[chunkId] + ".chunk.css";
};